import { Can } from 'providers/casl'
import { onAbTestsAccess } from '../features/abTests'
import { onAdUnitAccess } from '../features/adUnit'
import { onDomainAccess, onDomainRichPlacementsMultiAnchorAccess } from '../features/domain'
import { onGlobalSetupAmazonAccess } from '../features/globalSetup/amazon'
import { onGlobalSetupAccess } from '../features/globalSetup/common'
import {
  onGlobalSetupDefaultsPrebidStackAccess,
  onGlobalSetupDefaultsRichPlacementsAccess,
} from '../features/globalSetup/defaults'
import { onGlobalSetupGoogleAdManagerConnectionAccess } from '../features/globalSetup/googleAccountManagerConnection'
import {
  onGlobalSetupBiddersGeneralBidderConfigRead,
  onGlobalSetupPrebidBiddersAccess,
  onGlobalSetupPrebidModuleAccess,
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead,
  onGlobalSetupPrebidProtectionAccess,
} from '../features/globalSetup/prebid'
import { onGlobalSetupSupplyChainAccess } from '../features/globalSetup/supplyChain'
import { onHistoryAccess } from '../features/history'
import {
  onGamAccountSidebarItemAccess,
  onHelpMenuItemAccess,
  onLayoutAccess,
} from '../features/layout'
import { onPageAccess } from '../features/page'
import {
  onPerformanceAllProductAccess,
  onPerformanceGeneralAccess,
  onPerformanceYieldbirdDemandAccess,
} from '../features/performance'
import { onPortalAccess } from '../features/portal'
import { onProductAccess } from '../features/product'
import { onTagAccess } from '../features/tag'

export const onViewer = (can: Can) => {
  onAbTestsAccess(can)
  onAdUnitAccess(can)
  onDomainAccess(can)
  onDomainRichPlacementsMultiAnchorAccess(can)
  onGamAccountSidebarItemAccess(can)
  onGlobalSetupAccess(can)
  onGlobalSetupAmazonAccess(can)
  onGlobalSetupBiddersGeneralBidderConfigRead(can)
  onGlobalSetupDefaultsPrebidStackAccess(can)
  onGlobalSetupDefaultsRichPlacementsAccess(can)
  onGlobalSetupGoogleAdManagerConnectionAccess(can)
  onGlobalSetupPrebidBiddersAccess(can)
  onGlobalSetupPrebidModuleAccess(can)
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead(can)
  onGlobalSetupPrebidProtectionAccess(can)
  onGlobalSetupSupplyChainAccess(can)
  onHelpMenuItemAccess(can)
  onHistoryAccess(can)
  onLayoutAccess(can)
  onPageAccess(can)
  onPerformanceAllProductAccess(can)
  onPerformanceGeneralAccess(can)
  onPerformanceYieldbirdDemandAccess(can)
  onPortalAccess(can)
  onProductAccess(can)
  onTagAccess(can)
}
